<template>
    <section class="mt-16">
      <v-row class="d-none d-lg-block  mx-1 px-1">
            <v-col cols="12">
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    light
                  ></v-breadcrumbs>
  
                    <h1 class="primary--text">
                    <v-icon color="primary">mdi-hard-hat</v-icon> <span>Registo Diário KPI</span>
                    </h1>
  
                    <div class="mt-16">
                      <DiaryKPI method="create"></DiaryKPI>
                </div>
            </v-col>
        </v-row>

        <v-row class="d-block d-lg-none">
            <v-col cols="12">
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    light
                  ></v-breadcrumbs>
  
                    <h1 class="primary--text">
                    <v-icon color="primary">mdi-hard-hat</v-icon> <span>Registo Diário KPI</span>
                    </h1>
  
                    <div class="mt-16">
                      <DiaryKPI method="create"></DiaryKPI>
                </div>
            </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import DiaryKPI from '@/components/Diaries/Kpi/DiaryKPIView.vue'
  
  export default {
    components: {
        DiaryKPI
    },
    data: () => ({
      
    }),
    mounted(){
      if(!this.$store.getters.hasPermission(["super", "kpi_diaries.create"])) {
            this.$router.push('/forbidden');
        }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
            {
                text: 'Registo Diário KPI',
                disabled: true,
                to: '#',
                exact: true,
            },
        ];
      }
    }
  };
  </script>
  